import { IHisInfoItemBehavior } from "./IHisInfoItemBehavior";
import { HisInformationItem } from "../..";
import { IHisInformationValue, HisInformationTextValue } from "../../HisInformationValue";
import { DefaultTextBehavior } from "./DefaultTextBehavior";

/** HIS項目血圧を生成する */
export class PtBldPressureBehavior implements IHisInfoItemBehavior {
  private static readonly Key = "PT_BLD_PRESSURE";
  private static readonly PtBldPressureLowKey = "PT_BLD_PRESSURE_LOW";
  private static readonly PtBldPressureHighKey = "PT_BLD_PRESSURE_HIGH";
  
  getValue(hisInfoItems: HisInformationItem[]): IHisInformationValue {
    const itemValues =  hisInfoItems.filter(x => x.name === PtBldPressureBehavior.Key).map(x => x.value);
    const lowBehavior = new DefaultTextBehavior(PtBldPressureBehavior.PtBldPressureLowKey);
    const highBehavior = new DefaultTextBehavior(PtBldPressureBehavior.PtBldPressureHighKey);
    const lowValues = lowBehavior.getValue(hisInfoItems).data as string[];
    const highValues = highBehavior.getValue(hisInfoItems).data as string[];
    const values = (lowValues.length === highValues.length)
      ? lowValues.map((x, i) => formatBldPressure(x, highValues[i]))
      : [];
    const data = itemValues.length > 0 ? itemValues : values;
    return new HisInformationTextValue(PtBldPressureBehavior.Key, data);
  }
}

function formatBldPressure(low: string, high: string): string {
  return high + "/" + low;
}
